import { render, staticRenderFns } from "./RowMessage.vue?vue&type=template&id=423147e7"
import script from "./RowMessage.vue?vue&type=script&lang=js"
export * from "./RowMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports